import React from "react";
import PropTypes from "prop-types";

import BeatTheYeti from "../BeatTheYeti";
import CardScope, { useCardScope } from "./index";
import CardBusy from "./CardBusy";

/**
 * Beat the Yeti, pointed at whichever workspaces and dates the card's settings
 * say — and averaged.
 */
const ScopedBeatYeti = ({ settings, title, variant, ownWorkspaceId, editing, onSettings, boardWs, boardWindow, boardCustom, inheritWorkspaceIds }) => {
  const scope = useCardScope(settings, ownWorkspaceId, boardWs, { window: boardWindow, custom: boardCustom }, inheritWorkspaceIds);
  const showScope = !scope.navControlled;
  const busy = !!(scope.loading || scope.refreshing);

  const { pick } = scope;
  const setPick = (v) => {
    scope.choose(v);
    if (onSettings) onSettings({ ...settings, cardPick: v });
  };

  let { kpis } = scope;
  if (scope.byPlayer && pick !== "all") {
    const who = scope.people.find((p) => String(p.userId) === String(pick));
    kpis = scope.kpis.map((k) => ({
      ...k,
      amount: Number(who?.kpis?.[String(k._id)]?.amt) || 0,
      points: Number(who?.kpis?.[String(k._id)]?.pts) || 0,
    }));
  }

  return (
    <div className={`cs-wrap${scope.refreshing ? " cs-is-refreshing" : ""}`}>
      {showScope && (
        <CardScope
          scope={{ ...scope, pick }}
          onPick={setPick}
          editing={editing}
        />
      )}
      <CardBusy
        active={busy}
        cover={!!scope.loading || !kpis.length}
        label={scope.loading ? "Loading metrics…" : "Updating for date range…"}
      />
      {kpis.length ? (
        <BeatTheYeti
          kpis={kpis}
          yeti={scope.yeti}
          title={title}
          variant={variant}
          window={scope.window}
        />
      ) : (
        <div className="cs-emptyframe">
          {title && <div className="cs-emptyframe-h">{title}</div>}
          <div className="cs-empty">
            {scope.loading ? null : (
              <>
                <b>{scope.reading.length > 1 ? "No metric in common" : "No live metrics yet"}</b>
                {scope.reading.length > 1
                  ? "These workspaces don’t track the same metrics, so there is nothing fair to average. Align them and the tiles appear."
                  : "Mark a metric live on the workspace and it shows up here."}
              </>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

ScopedBeatYeti.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  settings: PropTypes.object,
  title: PropTypes.string,
  variant: PropTypes.string,
  ownWorkspaceId: PropTypes.string,
  editing: PropTypes.bool,
  onSettings: PropTypes.func,
  boardWs: PropTypes.string,
  boardWindow: PropTypes.string,
  // eslint-disable-next-line react/forbid-prop-types
  boardCustom: PropTypes.object,
  inheritWorkspaceIds: PropTypes.arrayOf(PropTypes.string),
};
ScopedBeatYeti.defaultProps = {
  settings: {},
  title: undefined,
  variant: undefined,
  ownWorkspaceId: null,
  editing: false,
  onSettings: null,
  boardWs: null,
  boardWindow: null,
  boardCustom: null,
  inheritWorkspaceIds: [],
};

export default ScopedBeatYeti;
